import { call, put, select, takeEvery } from 'redux-saga/effects';

import camelcaseKeys from 'camelcase-keys';
import { normalize } from 'normalizr';
import * as actions from '../../../actions/static-catalogs/cellular-providers';
import * as authSelectors from '../../../reducers/auth';
import * as schemas from '../../../schemas/cellular-providers';
import * as types from '../../../types/static-catalogs/cellular-providers';
import API_BASE_URL from '../../settings/apibaseurl';
/* -------------------------------------------------------------------------- */
/*                                 FETCH LIST                                 */
/* -------------------------------------------------------------------------- */
function* fetchProvidersList(action) {
  const country = action.payload;
  try {
    const isAuth = yield select(authSelectors.isAuthenticated);
    if (isAuth && (country || country === 0)) {
      const token = yield select(authSelectors.getAuthToken);
      const response = yield call(fetch, `${API_BASE_URL}/provider/get`, {
        method: 'POST',
        body: JSON.stringify({ country }),
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        }
      });
      const jsonResult = yield response.json();
      if (response.status <= 300 && jsonResult.success) {
        const resultData = jsonResult.data.map((result) => camelcaseKeys(result));
        const {
          entities: { providers },
          result //order
        } = normalize(resultData, schemas.providers); //normalize data to byId and order
        yield put(actions.completeFetchingProviders(providers, result));
      } else {
        const error = {
          errorMessage: jsonResult.message,
          errorNumber: jsonResult.number
        };
        // alerts.showErrorAlertFailChanges({ error });
        yield put(actions.failFetchingProviders(error));
      }
    }
  } catch (err) {
    const error = {
      errorMessage: err.toString(),
      errorNumber: -1
    };
    // alerts.showErrorAlertFailChanges({ error });
    yield put(actions.failFetchingProviders(error));
  }
}

export function* watchFetchProvidersList() {
  yield takeEvery(types.PROVIDERS_FETCH_STARTED, fetchProvidersList);
}
